import { useStore } from 'vuex';
import useGoogleAdsManager from '@common-vue/site-monetization/src/composables/useGoogleAdsManager';
import { useEnvProps } from '@composables/useEnvProps';
import { usePageData } from '@composables/usePageData';
import { useDeviceType } from '@composables/utils/useDeviceType';
import { useKillswitches } from '@modules/featureControl';

export default function useSiteMonGAMTags() {
  const store = useStore();
  const {
    referrer,
    product,
    topLevelCategoryID,
    brandName,
  } = usePageData();
  const { killswitches } = useKillswitches();
  const { isMobile } = useDeviceType();
  const { brand, tagMngrEnv } = useEnvProps();
  const tagParams = {
    store,
    device: isMobile.value ? 'mobile' : 'desktop',
    page: 'pdp',
    enableGAMAdsFromApp: killswitches?.enableGAMAdsFromApp || false,
    enableGAMImpressionTags: killswitches?.enableGAMImpressionTags || false,
    enableGAMClickTags: killswitches?.enableGAMClickTags || false,
    refererURL: referrer || '',
    tagEnv: tagMngrEnv,
    brand,
    productBrand: brandName,
    catID: product?.analytics?.data?.t_category_id[0] || '',
    topLevelCatID: topLevelCategoryID || '',
  };
  useGoogleAdsManager.initGAMTags(tagParams);
}
